import React, { useEffect, useState } from "react";
import { apiCallSPPost, apiDownloadDocument } from "src/_apiConfig/apiCall";
import CommonList from "src/views/common/CommonList";
import TableButtonClick from "src/views/common/Table/TableButtonClick";

const RevertHistory = (props) => {
  const [usersData, setUsersData] = useState(); // List Data Set
  const [loading, setloading] = useState(false); // page loading

  useEffect(() => {
    getReportList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isSearch]);

  // Page  API URL manage
  const ListUrl = `BackendActivity/ReverseEntry/HistoryList`;

  // api data manage
  const getdata = () => {
    const data = JSON.stringify({
      tenderNo: props.tenderNo,
      lot_no: props.lot_no,
      collection_season:
        props.collection_season === null ||
        props.collection_season === undefined
          ? 0
          : Number(props.collection_season),
      reverse_type_id: Number(props.reverse_type_id),
    });
    console.log("getdata", data);
    return data;
  };
  // get Report List
  const getReportList = async () => {
    if (
      props.lot_no !== "" &&
      props.lot_no !== undefined &&
      props.tenderNo !== "" &&
      props.tenderNo !== undefined
    ) {
      setloading(true);
      setUsersData([]);

      console.log("ddddd", props.collectionSeason, props.lot_no);
      await apiCallSPPost(ListUrl, getdata(), [])
        .then((res) => {
          if (res.success && res.totalRecord > 0) {
            console.log(res.data);
            setUsersData(res.data);
          } else setUsersData();
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  const handleDownloadHistoryDocument = async (
    tenderid,
    lotId,
    reverseEntryHistoryId
  ) => {
    const header = new Headers();
    let folderName = "";
    if (props.reverse_type_id === 1) folderName = "IncomeTaxConcession";
    else if (props.reverse_type_id === 2) folderName = "ABS";
    else if (props.reverse_type_id === 3) folderName = "AdjustAmtFormDFO";
    console.log(
      "handleDownloadHistoryDocument :",
      folderName + "|" + tenderid + "|" + lotId + "|" + reverseEntryHistoryId
    );
    const url = `BackendActivity/ReverseEntry/DownloadHistoryDocument?reverseTypeId=${props.reverse_type_id}&tenderId=${tenderid}&lotId=${lotId}&reverseEntryHistoryId=${reverseEntryHistoryId}`;
    const fileName =
      folderName +
      "_" +
      lotId +
      "_" +
      tenderid +
      "_" +
      reverseEntryHistoryId +
      ".pdf";
    await apiDownloadDocument(fileName, url, "GET", header, null).then(
      (res) => {
        if (res.success) alert(res.message);
        else alert(res.message);
      }
    );
  };

  let scopedSlotsList = {
    DownloadHistoryDocument: (item, index) => {
      return (
        <TableButtonClick
          isDisplayAllow={true}
          buttonName={"Download"}
          onClick={() =>
            handleDownloadHistoryDocument(
              item.tenderId,
              item.lotId,
              item.reverseEntryHistoryId
            )
          }
        />
      );
    },
  };
  let fields = "";
  if (props.reverse_type_id === 1) {
    fields = [
      {
        key: "tenderNo",
        _style: { width: "6.5%" },
        label: "Tender No.",
      },
      {
        key: "lotNo",
        _style: { width: "6.5%" },
        label: "Lot No.",
      },
      {
        key: "companyName",
        _style: { width: "15%" },
        label: "Company Name",
      },

      {
        key: "approvalDate",
        _style: { width: "7.5%" },
        label: "Approval Date",
      },

      {
        key: "insertDateTime",
        _style: { width: "7.5%" },
        label: "Revert Date",
      },
      {
        key: "insertedByName",
        _style: { width: "7.5%" },
        label: "Revert By",
      },
      {
        key: "reverseEntryComment",
        _style: { width: "5%" },
        label: "Comment",
      },
      {
        key: "reverseSubTypeName",
        label: "Payment Of",
        _style: { width: "10%" },
        sorter: false,
        filter: false,
      },
      {
        key: "DownloadHistoryDocument",
        label: "Download Document",
        _style: { width: "1%" },
        sorter: false,
        filter: false,
      },
    ];
  } else {
    fields = [
      {
        key: "tenderNo",
        _style: { width: "6.5%" },
        label: "Tender No.",
      },
      {
        key: "lotNo",
        _style: { width: "6.5%" },
        label: "Lot No.",
      },
      {
        key: "companyName",
        _style: { width: "15%" },
        label: "Company Name",
      },

      {
        key: "approvalDate",
        _style: { width: "7.5%" },
        label: "Approval Date",
      },

      {
        key: "insertDateTime",
        _style: { width: "7.5%" },
        label: "Revert Date",
      },
      {
        key: "insertedByName",
        _style: { width: "7.5%" },
        label: "Revert  By",
      },
      {
        key: "reverseEntryComment",
        _style: { width: "5%" },
        label: "Comment",
      },

      {
        key: "DownloadHistoryDocument",
        label: "Download Document",
        _style: { width: "1%" },
        sorter: false,
        filter: false,
      },
    ];
  }

  return (
    <>
      <CommonList
        items={usersData}
        fields={fields}
        scopedSlots={scopedSlotsList}
        listName="Revert History "
        loading={loading}
        disabledprev={true}
        disablednext={true}
        isAfterSearchDataDisplay={true}
      />
    </>
  );
};

export default RevertHistory;
